document.querySelector('[data-load-more]').addEventListener('click', function () {
    let thisButton = this, totalPages = parseInt(document.querySelector('[data-total-pages]').value), currentPage = parseInt(document.querySelector('[data-current-page]').value), totalproducts = parseInt(document.querySelector('[data-total-products]').value);

    thisButton.setAttribute('disabled', true);
    thisButton.querySelector('.loading__spinner').classList.remove('hidden');
    currentPage += 1;
    let nextUrl = document.querySelector('[data-next-url]').value.replace(/page=[0-9]+/, 'page=' + currentPage);
    document.querySelector('[data-current-page]').value = currentPage;
    fetch(nextUrl)
        .then(response => response.text())
        .then(responseHTML => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(responseHTML, 'text/html');
            // append next page of products to the current page
            document.querySelector('.product-grid').innerHTML += doc.querySelector('.product-grid').innerHTML;
            // get the number of visible products on the page
            let numVisibleProducts = document.querySelectorAll('.product-grid li').length;
            // update the product count
            document.querySelector('.product-count p').textContent = `Showing ${numVisibleProducts} of ${totalproducts} Items`;

            if (currentPage < totalPages) {
                thisButton.removeAttribute('disabled');
                thisButton.querySelector('[load-more-text]').classList.remove('hidden');
                thisButton.querySelector('.loading__spinner').classList.add('hidden');
            } else {
                thisButton.classList.add('hidden');
            }
        });
});
